import type { CardFieldItemProps, Field } from './ProfileUserDataCard.types';
import type { ReactElement } from 'react';

import { Card, DataList, Flex, Skeleton } from '@rango-dev/whale';
import React from 'react';

import { HoverCard } from '../HoverCard';

import styles from './ProfileUserDataCard.module.css';

const SKELETON_LABEL_WIDTH = '120px';
const SKELETON_VALUE_WIDTH = '50px';
const SKELETON_ROW_HEIGHT = '20px';

export function CardFieldItem(props: CardFieldItemProps): ReactElement {
  if ('loading' in props) {
    return (
      <DataList.Item>
        <DataList.Label>
          <Skeleton width={SKELETON_LABEL_WIDTH} height={SKELETON_ROW_HEIGHT} />
        </DataList.Label>
        <DataList.Value className={styles.value}>
          <Skeleton width={SKELETON_VALUE_WIDTH} height={SKELETON_ROW_HEIGHT} />
        </DataList.Value>
      </DataList.Item>
    );
  }

  const { label, value, description } = props;

  return (
    <DataList.Item align="center">
      <DataList.Label color="gray">
        <Flex align="center" gap="2">
          {label}
          {description && <HoverCard description={description} />}
        </Flex>
      </DataList.Label>
      <DataList.Value className={styles.value}>{value === undefined ? '-' : value}</DataList.Value>
    </DataList.Item>
  );
}

export function ProfileUserDataCard(props: {
  header: ReactElement;
  fields: Field[];
}): ReactElement {
  const { header, fields } = props;

  return (
    <Card variant="surface" size="3">
      <Flex direction="column" gap="2">
        {header}
        <DataList.Root size="2">
          {fields.map((field) => (
            <CardFieldItem
              key={field.id}
              label={field.label}
              value={field.value}
              description={field.description}
            />
          ))}
        </DataList.Root>
      </Flex>
    </Card>
  );
}
